const bookShopAddress = (state = "", action) => {
    switch(action.type) {
        case 'bookShopAddress':
            return action.payload;
        default:
            return state;
    }
}

export default bookShopAddress;